/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const Direction = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type Direction = ClosedEnum<typeof Direction>;

/**
 * Sort a grouped result by one of its measures.
 */
export type AnalyticsOrderBy = {
  direction?: Direction | undefined;
  /**
   * Alias of a requested measure
   */
  measure: string;
};

/** @internal */
export const Direction$outboundSchema: z.ZodMiniEnum<typeof Direction> = z.enum(
  Direction,
);

/** @internal */
export type AnalyticsOrderBy$Outbound = {
  direction: string;
  measure: string;
};

/** @internal */
export const AnalyticsOrderBy$outboundSchema: z.ZodMiniType<
  AnalyticsOrderBy$Outbound,
  AnalyticsOrderBy
> = z.object({
  direction: z._default(Direction$outboundSchema, "desc"),
  measure: z.string(),
});

export function analyticsOrderByToJSON(
  analyticsOrderBy: AnalyticsOrderBy,
): string {
  return JSON.stringify(
    AnalyticsOrderBy$outboundSchema.parse(analyticsOrderBy),
  );
}
